import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setRedirectToLeads } from '../app-context/leadsSlice';
import { useNavigate } from 'react-router-dom';

interface Props {
    show: boolean;
    onClose: Function;
    leadId: string;
    lead: any;
}

export const OfferProductionSuccessNavigateToLead: FC<Props> = (props: Props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        if (props.leadId) {
            dispatch(setRedirectToLeads(true));
            console.log('saveOfferBtn clicked', props.leadId);
            localStorage.setItem('offeredLeadId', props.leadId);
            setTimeout(() => {
                gotoLeads()
            }, 300)
        }

    }, [])

    const gotoLeads = () => {
        if (props.lead) {
            const lastFilterStr = localStorage.getItem('lastLeadsFilter');
            let savedFilter: any = {};
            if (lastFilterStr && lastFilterStr !== '{}') {
                console.log('JSON.parse(lastFilterStr)', JSON.parse(lastFilterStr))
                savedFilter = JSON.parse(lastFilterStr);
                // savedFilter.searchText = ownerCustomer.firstName + " " + ownerCustomer.lastName;
                savedFilter.searchText = props.lead.firstName + " " + props.lead.lastName;
                savedFilter.createDateFrom = null;
                savedFilter.SortBy = null;
                console.log('lastLeadsFilter', JSON.stringify(savedFilter))

                localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
            }
        }

        navigate('/Leads');
        props.onClose && props.onClose();
    }
    return null;
}
